import { Card, Grid, Tabs, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import InteractionCard from '../../components/InteractionCard';
import ProductFeedSelector from '../../components/ProductFeeds/ProductFeedSelector';
import ContextProducts from '../../components/Products/ContextProducts';
import ProductCard from '../../components/Products/ProductCard';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';
const tabsNav = ['recentlyViewed', 'recentlyAddedToCart', 'popularPurchases', 'popularCartAdditions', 'last3Months'];

const ProfilesDetailsProductInteractionsPage = ({ profile }) => {
  const location = useLocation();
  const search = queryString.parse(location.search);
  const fetch = useFetch();
  const navigate = useNavigate();
  const interactionTab = search.interactionTab || tabsNav[0];
  const [interactions, setInteractions] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();
  const [productFeedId, setProductFeedId] = useState();
  const [products, setProducts] = useState();

  useEffect(() => {
    fetch(
      `/api/admin/accounts/${accountId}/domains/${domainId}/profiles/interactions?profileId=${encodeURIComponent(
        profile.profileId
      )}`,
      {}
    )
      .then(({ interactions }) => {
        setInteractions(interactions);
      })
      .catch(setError);
  }, [accountId, domainId, fetch, profile.email, profile.profileId]);

  useEffect(() => {
    if (!productFeedId || !profile) {
      return;
    }
    const email = profile.email;
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/testProductFeed`, {
      method: 'POST',
      body: JSON.stringify({ email, productFeedId }),
    })
      .then(({ productSources }) => {
        setProducts(productSources);
      })
      .catch(setError);
  }, [accountId, domainId, fetch, productFeedId, profile]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (!interactions) {
    return <Spinner />;
  }

  const setInteractionTab = (interactionTab) => {
    navigate(
      `${location.pathname}?${queryString.stringify({
        ...search,
        interactionTab,
      })}`
    );
  };

  const mostViewedCategories = Object.keys(interactions.values.lastViewedContext.categories || {});
  const mostViewedCategoryElements = [];
  let row = [];
  for (let i = 0; i < mostViewedCategories.length; i++) {
    const category = mostViewedCategories[i];
    const count = interactions.values.lastViewedContext.categories[category];
    row.push(
      <Grid.Col key={i} span={{ base: 6, md: 2 }}>
        <InteractionCard key={category} title={category} count={count} />
      </Grid.Col>
    );
    if ((i > 0 && (i + 1) % 6 === 0) || i === mostViewedCategories.length - 1) {
      mostViewedCategoryElements.push(
        <Grid style={{ paddingTop: '10pt' }} key={i}>
          {row}
        </Grid>
      );
      row = [];
    }
  }
  const mappedProducts = products?.map((product) => (
    <Grid.Col key={product.id} span={{ base: 6, md: 2 }}>
      <ProductCard product={product} />
    </Grid.Col>
  ));

  return (
    <>
      <Card withBorder mb="sm">
        <Card.Section inheritPadding py="md">
          <Text fw={500} size="lg">
            Most Viewed Categories
          </Text>
          <hr />
          {mostViewedCategoryElements.length > 0 ? (
            mostViewedCategoryElements
          ) : (
            <div style={{ textAlign: 'center' }}>No categories found.</div>
          )}
        </Card.Section>
      </Card>

      <Tabs value={interactionTab} onChange={setInteractionTab} m={0}>
        <Tabs.List>
          <Tabs.Tab value="recentlyViewed">Recently Viewed</Tabs.Tab>
          <Tabs.Tab value="recentlyAddedToCart">Recently Added to Cart</Tabs.Tab>
          <Tabs.Tab value="recentlyPurchased">Recently Purchased</Tabs.Tab>
          <Tabs.Tab value="testProductFeed">Products from Feed</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="recentlyViewed">
          <Card withBorder mb="sm">
            <Card.Section inheritPadding py="md">
              <ContextProducts interactions={interactions} contextKey="lastViewedContext" />
            </Card.Section>
          </Card>
        </Tabs.Panel>

        <Tabs.Panel value="recentlyAddedToCart">
          <Card withBorder mb="sm">
            <Card.Section inheritPadding py="md">
              <ContextProducts interactions={interactions} contextKey="lastAddedToCartContext" />
            </Card.Section>
          </Card>
        </Tabs.Panel>

        <Tabs.Panel value="recentlyPurchased">
          <Card withBorder mb="sm">
            <Card.Section inheritPadding py="md">
              <ContextProducts interactions={interactions} contextKey="lastPurchasedContext" />
            </Card.Section>
          </Card>
        </Tabs.Panel>

        <Tabs.Panel value="testProductFeed">
          <Card withBorder mb="sm">
            <Card.Section inheritPadding py="md">
              <Grid align="center">
                <Grid.Col span={{ base: 12, sm: 2 }}>
                  <Text fw={500}>Product Feed*</Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 10 }}>
                  <ProductFeedSelector
                    scope="marketingChannels"
                    accountId={accountId}
                    domainId={domainId}
                    productFeedId={productFeedId}
                    onSelect={(id) => setProductFeedId(id)}
                    forType="recommender"
                  />
                </Grid.Col>
              </Grid>
            </Card.Section>
          </Card>
          {mappedProducts && (
            <Card withBorder mb="sm">
              <Card.Section inheritPadding py="md">
                <Grid>{mappedProducts}</Grid>
              </Card.Section>
            </Card>
          )}
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default ProfilesDetailsProductInteractionsPage;
